define('SageDotCom/Components/Forms/AccountingForm',[
    "jquery"
], function ($) {
    function AccountingForm() { }

    var canSendOtp = true;

    function addSageAccountingFormObserver() {
        var targetNode = document.querySelector(".accounting-form").parentNode.parentNode;
        var config = { attributes: true, childList: true, subtree: true };

        // Callback function to execute when mutations are observed
        var callback = function (mutationsList, observer) {
            for (var mutation in mutationsList) {
                var mutationItem = mutationsList[mutation];
                if (mutationItem.type === "childList") {
                    if (!$(".accounting-form input[type='submit']").hasClass("with-loader")) {
                        $(".accounting-submit-form input[type='submit'].disabled").removeClass("disabled");
                        $(".accounting-submit-form input[type='submit']").removeAttr("disabled");
                        $(".accounting-form .otp-button").val($(".accounting-form-resend-msg").text());
                        $(".accounting-form-otp-sent").removeClass("hidden");
                        $(".accounting-submit-form").find(".dynamic-required").each(function () {
                            var $input = $(this);
                            $input.prop("required", true);
                            $input.next(".error").remove();
                        });
                    }

                    $(".accounting-form input[type=submit].otp-button").attr("type", "button");
                    $(".accounting-submit-form input[type='submit']").on("click", function () {
                        var parent = $(this).parent();
                        var anyErrors = parent.parent().find(".field-validation-error");
                        if ($("form").valid() === true && anyErrors.length <= 0) {
                            if (!$(this).hasClass("with-loader")) {
                                addSpinner($(this), parent);
                            }
                        }
                    });

                    $(".accounting-form .otp-button").on("click", function () {
                        //Stop OTP from being sent multiple times due to being within an observer
                        if (canSendOtp) {
                            canSendOtp = false;
                            sendOtpMsg();
                        }

                        setTimeout(function () {
                            canSendOtp = true;
                        }, 500);
                    });
                }
            }
        };

        // Create an observer instance linked to the callback function
        var observer = new MutationObserver(callback);
        // Start observing the target node for configured mutations
        observer.observe(targetNode, config);
    }
    function addSpinner(submit, context) {
        submit.addClass("with-loader");
        submit.val("");
        context.append("<div class='loader'></div>");
        var spinner = context.find(".loader");
        spinner.append("<div class='bounce bounce1'></div>");
        spinner.append("<div class='bounce bounce2'></div>");
        spinner.append("<div class='bounce bounce3'></div>");
    }
    function removeSpinner(submit, context) {
        submit.removeClass("with-loader");
        var spinner = context.find(".loader");
        spinner.remove();
    }

    function sendOtpMsg() {
        var parent = $(this).parent();
        addSpinner($(this), parent);

        var number = $(".otp-telephone").val();
        var formId = $(".accounting-form").attr("id");
        var id = formId.substring(formId.length - 36);
        var terr = $("html").attr("lang").toLowerCase();

        if (terr && terr === "en-ae") {
            terr = "en-tv";
        }

        var tokenElement = $(`#${formId} input[name="__RequestVerificationToken"]`);
        var token = tokenElement.length > 0 ? tokenElement.val() : null;
        if (token) {
            $.ajax({
                type: "POST",
                url: "/api/sitecore/SendFormData/SendOtpMsg",
                headers: {
                    "__RequestVerificationToken": token
                },
                data: {
                    phoneNumber: number,
                    formId: id,
                    territory: terr
                },
                context: this
            }).done(function (response) {
                $(".accounting-submit-form input[type='submit'].disabled").removeClass("disabled");
                $(".accounting-submit-form input[type='submit']").removeAttr("disabled");

                $(".accounting-form .otp-button").val($(".accounting-form-resend-msg").text());
                $(".accounting-form-otp-sent").removeClass("hidden");

                $(".accounting-submit-form").find(".dynamic-required").each(function () {
                    var $input = $(this);
                    $input.prop("required", true);
                    $input.next(".error").remove();
                });

                removeSpinner($(this), parent);
            }).fail(function (response) {
                $(".accounting-form .otp-button").val($(".accounting-form-resend-msg").text());
                removeSpinner($(this), parent);
            });
        }
    }

    AccountingForm.prototype.init = function init() {

        $(".accounting-submit-form input[type='submit']").on("click", function () {
            var parent = $(this).parent();
            var anyErrors = parent.parent().find(".field-validation-error");
            if ($("form").valid() === true && anyErrors.length <= 0) {
                if (!$(this).hasClass("with-loader")) {
                    addSpinner($(this), parent);
                    addSageAccountingFormObserver();
                }
            }
        });

        $(".accounting-form .otp-button").on("click", function () {
            sendOtpMsg();
        });
    }


    return new AccountingForm();
});
